import { createElement, styled, compose, position, space, layout, flexbox, color, typography, border, opacity, float, boxShadow, pointerEvents, boxSizing, visibility, transition, textOverflow, textDecoration, textTransform, outline, cursor, whiteSpace, wordWrap } from '@vebox/etui-system';

const TdElement = createElement('td');
const Td = styled(TdElement)(compose(position, space, layout, flexbox, color, typography, border, opacity, float, boxShadow, pointerEvents, boxSizing, visibility, transition, textOverflow, textDecoration, textTransform, outline, cursor, whiteSpace, wordWrap));
Td.displayName = 'Td';

export { Td };
